import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ContactRequestCard.TaxSection', {
    tax: 'TAX',
    taxId: 'TAX ID Number',
    defaultSalesTax: 'Default sales tax',
    defaultPurchaseTax: 'Default purchase tax',
    companyNumber: 'Company Registration Number',
});
